export default {
  defaultOffset: '11',
  defaultPlacement: 'bottom-end',
  defaultTemplate: `
    <div class="apos-tooltip" role="tooltip">
      <div class="apos-tooltip__arrow"></div>
      <div class="apos-tooltip__inner"></div>
    </div>`,
  defaultArrowSelector: '.apos-tooltip__arrow',
  defaultInnerSelector: '.apos-tooltip__inner'
};
